import type ErrorDialogStore from './schema/ErrorDialogStore';
import { createStore } from 'satcheljs';
import './mutators/setLoadFailureDialogState';

let errorDialogStoreData: ErrorDialogStore = {
    loadFailureHidden: true,
    failureState: 'None',
};

export default createStore<ErrorDialogStore>('errorDialogStore', errorDialogStoreData);
